import {Tournament} from '@/services/internal/tournament/types';
import {VersusProps} from '@sdk-mobile';

export type TournamentJoinGuards = Partial<{
  balance: boolean;
  age: number;
  account: boolean;
  email: boolean;
  phone: boolean;
}>;

export type TournamentJoinOptions = Partial<
  VersusProps & {
    setID: number;
    isBotMatch: boolean;
    goStraightIntoMatch: boolean;
    withoutSession?: boolean; // Used to debounce join calls that start from initiateTournamentJoin
  }
>;

export type LSJoinTournamentData = Partial<{
  tournament: Tournament;
  options: TournamentJoinOptions;
  guards: TournamentJoinGuards;
}>;

export const JOIN_TOURNAMENT_LS_KEY = 'joinTournament';

export const getJoinSession = (): LSJoinTournamentData | undefined => {
  const session = sessionStorage.getItem(JOIN_TOURNAMENT_LS_KEY);

  try {
    return session ? JSON.parse(session) : undefined;
  } catch (e) {
    return;
  }
};

export const setJoinSession = (data: LSJoinTournamentData) => {
  sessionStorage.setItem(JOIN_TOURNAMENT_LS_KEY, JSON.stringify(data));
};

export const isAlreadyJoining = (tournament: Tournament) => {
  const currentlyJoining = getJoinSession();
  return currentlyJoining?.tournament && currentlyJoining.tournament.id === tournament.id;
};

export const removeJoinGuard = (guard: keyof TournamentJoinGuards) => {
  const session = getJoinSession();

  if (!session) {
    return;
  }

  try {
    const guards = session.guards ?? {};

    delete guards[guard];

    setJoinSession({...session, guards});
  } catch (e) {
    return;
  }
};

export const clearJoinSession = () => sessionStorage.removeItem(JOIN_TOURNAMENT_LS_KEY);
